module.exports = __webpack_public_path__ + "img/hr-red-croton-04.a19554c2.png";